import React from "react"
import { StaticQuery, graphql } from "gatsby"
import SocialLinks from "./social-links";
import Logo from "../assets/planet-argon-logo.svg";

const Header = () => (
  <StaticQuery
  query={graphql`
  {
    file(sourceInstanceName: {eq: "settings"}, name: {eq: "site-settings"}) {
      id
      name
      childMarkdownRemark {
        html
        frontmatter {
          site_title
          results_year
        }
      }
    }
  }
  `}
  render={data => (
      <div className="is-header has-background-image has-text-white" id="is-header">
        <div className="header-border-bottom is-header-top-row">
          <div className="is-header-container">
            <div className="columns is-header-column is-desktop">
              <div className="column is-one-quarter-desktop header-border-right desktop-only"></div>
              <div className="column is-header-details">
                <div className="is-header-logo">
                  <a href="http://www.planetargon.com" target="_blank">
                    <img src={Logo} alt="Planet Argon" />
                  </a>
                </div>
                <p className="is-header-descriptor">Proudly Presents</p>
              </div>
            </div>
          </div>
          <SocialLinks customClass="is-header-links is-hidden-mobile" showFullEmail={true} />
        </div>
        <div className="is-header-container">
          <div className="columns is-header-column is-desktop">
            <div className="column is-one-quarter-desktop header-border-right py-6 desktop-only"></div>
            <div className="column is-three-quarters-desktop py-6">
              <h1 className="is-header-headline">
                <span className="is-header-title-year">{data.file.childMarkdownRemark.frontmatter.results_year}</span>
                <span className="is-header-title">{data.file.childMarkdownRemark.frontmatter.site_title}</span>
              </h1>
            </div>
          </div>
        </div>
      </div>
    )}
  ></StaticQuery>
)

export default Header